import './TopArticles.scss'
import React from 'react'
import Divider from '../../../widgets/Layout/Divider'
import VerticalArticle from '../../../components/Article/List/Vertical'
import VerticalMarketSpace from '../../../components/MarketSpace/List/Vertical'
import translate from '../../../utilities/translate'
import SectionHeader from '../SectionHeader'
import translations from './translations'
import PropTypes from 'prop-types'
import { getLocales } from '../../../utilities/locales'
import { MARKET_SPACE_TYPE } from '../../../utilities/constants'

// trans :: String -> String -> String
const trans = translate(translations)

const TopArticles = ({
  locale,
  items = [],
  isFetching,
}) =>
  <div className="homepage-top-articles">
    <SectionHeader label={ trans(locale)('label') } link={ trans(locale)('link') }/>
    { isFetching
      ? <Placeholder length={ 6 } />
      : <section className="columns">
        { items.map(item =>
          <div key={ `${item.type}-${item.item.id}` } className="column col-6 col-sm-12">
            { item.type === MARKET_SPACE_TYPE
              ? <VerticalMarketSpace
                marketSpace={ item.item }
                sponsoredTitle={ item.isSponsored
                  ? (item.sponsoredTitle ?? trans(locale)('sponsored'))
                  : null
                }
              />
              : <VerticalArticle
                article={ item.item }
                size='small'
                sponsoredTitle={ item.isSponsored
                  ? (item.sponsoredTitle ?? trans(locale)('sponsored'))
                  : null
                }
              />
            }
            <Divider />
          </div>,
        ) }
      </section>
    }
  </div>

const Placeholder = ({ length }) =>
  <section className="columns vertical-top-articles">
    { Array.from({ length }).map(
      (_, idx) =>
        <div key={ idx } className="column col-6 col-sm-12">
          <VerticalArticle.Placeholder size='small' />
          <Divider />
        </div>,
    ) }
  </section>

TopArticles.propTypes = {
  locale: PropTypes.oneOf(getLocales()).isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  isFetching: PropTypes.bool.isRequired,
}

export default TopArticles
